var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"modal-header\">\n<h3 class=\"modal-title\">{{title}}</h3>\n</div>\n<form name=\"pick_company_form\" ng-submit=\"submit(pick_company_form)\">\n<div class=\"modal-body\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"pick_company_form\">\n</div>\n<div class=\"modal-footer\">\n<button type=\"submit\" class=\"btn btn-primary\" translate=\"MEMBER.MODAL.PICK_COMPANY.OK_BTN\">\n</button>\n<button type=\"button\" class=\"btn btn-default\" ng-click=\"cancel($event)\" translate=\"MEMBER.MODAL.PICK_COMPANY.CANCEL_BTN\">\n</button>\n</div>\n</form>\n";
var id1="core/_templates/pick_company_modal_form.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/_templates/pick_company_modal_form.html
// module id = 316
// module chunks = 0